/* Above Category — collection page behaviour (sections/main-collection, blocks/ac-filters, blocks/ac-collection-header).
   Everything is delegated from the document so it survives the Section Rendering API re-rendering the section
   (Horizon's facets.js morphs the section in place after every filter change; <details> and <dialog> keep their
   open state through the morph).
   1. Popovers (.ac-fpop, a <details>): one open at a time; click outside or Esc closes; aria-expanded follows the
      state; Apply closes; closing without Apply puts the checkboxes back to the server's state (defaultChecked), so
      a half-made choice is never sent along with the next sort or filter change.
   2. Drawer (dialog.ac-fdrawer): showModal() at every width (native focus trap, Esc, backdrop); slides in from the
      right; focus returns to the opener; "Show N results" closes. The page behind is locked.
   3. Read more: the statement's hidden paragraphs. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Popovers ---------- */
  function pops() { return Array.prototype.slice.call(document.querySelectorAll('details.ac-fpop[data-ac-pop]')); }
  function syncAria(d) {
    var s = d.querySelector(':scope > summary');
    var v = d.open ? 'true' : 'false';
    if (s && s.getAttribute('aria-expanded') !== v) s.setAttribute('aria-expanded', v);
  }
  function resetInputs(d) {
    d.querySelectorAll('input[type="checkbox"]').forEach(function (i) { if (i.checked !== i.defaultChecked) i.checked = i.defaultChecked; });
    d.querySelectorAll('.ac-fprice input').forEach(function (i) { if (i.value !== i.defaultValue) i.value = i.defaultValue; });
  }
  function closePop(d, opts) {
    if (!d.open) return;
    if (!(opts && opts.keep)) resetInputs(d);
    d.open = false;
  }
  function closeAll(except) { pops().forEach(function (d) { if (d !== except) closePop(d); }); }

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.classList.contains('ac-fpop')) return;
    syncAria(d);
    if (d.open) {
      closeAll(d);
      // anchor: keep the panel inside the viewport
      var p = d.querySelector('.ac-fpop__panel');
      if (p) {
        p.classList.remove('ac-fpop__panel--end');
        var r = p.getBoundingClientRect();
        if (r.right > window.innerWidth - 16) p.classList.add('ac-fpop__panel--end');
      }
    }
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    // Apply: the engine re-renders; close now (the morph keeps `open`, so it would otherwise stay).
    var apply = t.closest('[data-ac-apply]');
    if (apply) {
      var dd = apply.closest('details.ac-fpop');
      if (dd) { setTimeout(function () { closePop(dd, { keep: true }); }, 0); }
      return;
    }
    var pc = t.closest('[data-ac-price-clear]');
    if (pc) {
      var comp = document.getElementById(pc.getAttribute('data-ac-price-clear'));
      if (comp) {
        comp.querySelectorAll('input').forEach(function (i) { i.value = ''; });
        if (typeof comp.updatePriceFilterAndResults === 'function') comp.updatePriceFilterAndResults();
        var pd = pc.closest('details.ac-fpop');
        if (pd) setTimeout(function () { closePop(pd, { keep: true }); }, 0);
      }
      return;
    }
    // Sort rows: the change re-renders; close the sort popover.
    if (t.closest('.ac-fpop--sort .ac-radio')) {
      var sd = t.closest('details.ac-fpop');
      if (sd) setTimeout(function () { closePop(sd, { keep: true }); }, 150);
      return;
    }
    // Outside any open popover: close them all.
    if (!t.closest('details.ac-fpop')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = pops().filter(function (d) { return d.open; });
    if (!open.length) return;
    e.preventDefault();
    open.forEach(function (d) {
      closePop(d);
      var s = d.querySelector(':scope > summary');
      if (s) s.focus();
    });
  });

  // After a morph the summaries' aria-expanded comes back from the server as "false"; put it right. The morph
  // also rewrites class attributes, which strips .is-in from the editorial tile's [data-ac-reveal] card (ac-reveal.js
  // only arms what was there at load), so anything in the section still waiting to reveal is re-armed here.
  function armReveal(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ac-reveal]:not(.is-in)'));
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('ac-reveal--instant', 'is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }
  var raf = 0;
  var mo = new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      pops().forEach(syncAria);
      var sec = document.querySelector('.ac-collection');
      if (sec) armReveal(sec);
    });
  });
  function observe() {
    var sec = document.querySelector('.ac-collection');
    if (sec) mo.observe(sec, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
  }

  /* ---------- 2. Drawer ---------- */
  var opener = null;
  function drawerFor(t) {
    var id = t.getAttribute('data-ac-drawer-open');
    return id ? document.getElementById(id) : document.querySelector('dialog.ac-fdrawer');
  }
  function lock(on) {
    document.documentElement.classList.toggle('ac-fdrawer-open', on);
  }
  function openDrawer(dialog, from) {
    if (!dialog || dialog.open) return;
    closeAll();
    opener = from || null;
    dialog.classList.remove('is-closing');
    dialog.showModal();
    lock(true);
    document.querySelectorAll('[data-ac-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var first = dialog.querySelector('.ac-fdrawer__close');
    if (first) first.focus({ preventScroll: true });
  }
  function closeDrawer(dialog) {
    if (!dialog || !dialog.open) return;
    var finish = function () {
      dialog.classList.remove('is-closing');
      dialog.close();
      lock(false);
      document.querySelectorAll('[data-ac-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
      opener = null;
    };
    if (reduce) { finish(); return; }
    dialog.classList.add('is-closing');
    var done = false;
    var end = function () { if (done) return; done = true; dialog.removeEventListener('animationend', end); finish(); };
    dialog.addEventListener('animationend', end);
    setTimeout(end, 500);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var o = t.closest('[data-ac-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(drawerFor(o), o); return; }
    var c = t.closest('[data-ac-drawer-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('dialog.ac-fdrawer')); return; }
    // Backdrop: a click on the dialog element itself (outside the panel) closes.
    if (t instanceof HTMLDialogElement && t.classList.contains('ac-fdrawer')) closeDrawer(t);
  });
  // Esc: the browser fires cancel; run the slide-out instead of the instant close.
  document.addEventListener('cancel', function (e) {
    var d = e.target;
    if (d instanceof HTMLDialogElement && d.classList.contains('ac-fdrawer')) { e.preventDefault(); closeDrawer(d); }
  }, true);
  // Belt and braces: if the dialog was closed by other means, release the lock.
  document.addEventListener('close', function (e) {
    var d = e.target;
    if (d instanceof HTMLDialogElement && d.classList.contains('ac-fdrawer')) lock(false);
  }, true);

  /* ---------- 3. Read more ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var b = t.closest('.ac-chead__toggle');
    if (!b) return;
    var more = document.getElementById(b.getAttribute('aria-controls'));
    if (!more) return;
    var show = more.hidden;
    more.hidden = !show;
    b.setAttribute('aria-expanded', show ? 'true' : 'false');
    b.textContent = show ? (b.getAttribute('data-ac-less') || 'Read less') : (b.getAttribute('data-ac-more') || 'Read more');
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
})();
